import SweetAlert from "@components/Feedback/SweetAlert/Index";

export default function ValidationsUsuario() {

    // mensagens de confirmação antes do cadastro de acordo com o perfil selecionado
    const warningMessage = async (perfil) => {
        let title = "";
        let message = "";

        if (perfil === "AUDITOR") {
            title = "Cadastro de Auditor";
            message = `
                <div>
                    <strong>O perfil <span style="color: #2b97be">AUDITOR</span> é o <u>Administrador do sistema</u>.</strong><br/>
                    <ul style="margin:8px 0 0 18px; padding:0;">
                        <li><b>Acesso total</b> a todos os módulos do sistema;</li>
                        <li>Visualização, edição e exclusão de qualquer informação;</li>
                        <li>Permissão para gerenciar usuários e configurações globais.</li>
                    </ul>
                    <br/>
                    <span>Tem certeza que deseja cadastrar este usuário como AUDITOR?</span>
                </div>
            `;
        } else if (perfil === "GERENTE" || perfil === "ENCARREGADO") {
            title = `Cadastro de ${perfil.charAt(0) + perfil.slice(1).toLowerCase()}`;
            message = `
                <div>
                    <strong>O perfil <span style="color: #2b97be">${perfil}</span> possui acesso restrito à sua unidade/gerência.</strong>
                    <br/>
                    <ul style="margin:8px 0 0 18px; padding:0;">
                        <li>Visualiza e gerencia informações apenas da sua <b>Unidade/Gerência</b>;</li>
                        <br/>
                        <li>Este usuário só será ativado após associá‑lo a uma <b>Unidade/Gerência</b>;</li>
                    </ul>
                    <br/>
                    <span>Deseja realmente cadastrar este usuário como ${perfil}?</span>
                </div>
            `;
        } else if (perfil === "VISITANTE") {
            title = "Cadastro de Visitante";
            message = `
                <div>
                    <strong>O perfil <span style="color: #2b97be">VISITANTE</span> possui apenas <u>acesso de visualização</u>.</strong>
                    <br/>
                    <ul style="margin:8px 0 0 18px; padding:0;">
                        <li>Não pode editar nem excluir informações;</li>
                        <br/>
                        <li>Apenas consulta dados do sistema;</li>
                        <br/>
                        <li>Este usuário terá acesso apenas aos dados da solicitação atribuída;</li>
                    </ul>
                    <br/>
                    <span>Confirma o cadastro deste usuário como VISITANTE?</span>
                </div>
            `;
        }

        // Mostra o modal de confirmação
        const warning = await SweetAlert.warningHTML(title, message);

        // Só retorna true se o usuário confirmar explicitamente
        return !!warning;
    }

    const validateEmail = (emails) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const errors = {};

        if (!emailRegex.test(emails.email)) {
            errors.email = "O E-mail do Usuário é inválido.";
        }

        return errors;
    };


    return { warningMessage, validateEmail };
}
